export default __webpack_public_path__ + "static/media/CNo.41-5.cd04e8fb.jpg";